<template>
  <section class="ct-newsletter">
    <div class="ct-newsletter__container container">
      <div class="ct-newsletter__content">
        <div
          v-if="slice.Title"
          class="ct-newsletter__heading heading--4"
        >
          {{ slice.Title }}
        </div>

        <p class="ct-newsletter__subtitle">
          {{ $t('Subscribe to our newsletter now') }}
        </p>

        <FormNewsletter class="ct-newsletter__form" />
      </div>

      <AppUsps
        v-if="slice.Usp?.Usp?.length"
        :usps="slice.Usp.Usp"
        class="ct-newsletter__usps"
      />
    </div>

    <!-- <pre>slice: {{ slice }}</pre> -->
  </section>
</template>

<script lang="ts" setup>
defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
  context: {
    type: [Object, Array],
    default: () => null,
  },
})
</script>

<style src="~layers/app/components/Slices/Newsletter.css" />
